export default __webpack_public_path__ + "static/media/back_btn.fc8658d7.svg";